import { reportNavigation } from "./browser";

// Client-side navigation timing: instrumentation-client.ts marks the start
// (onRouterTransitionStart), components/telemetry-reporter.tsx the end (the
// new pathname committed). One pending navigation at a time; a newer one
// replaces it.

let pending: { startPerf: number; startEpoch: number } | null = null;

export function startNavigation(): void {
  pending = { startPerf: performance.now(), startEpoch: Date.now() };
}

export function finishNavigation(): void {
  if (!pending) return;
  const { startPerf, startEpoch } = pending;
  pending = null;
  reportNavigation("browser.navigation", startEpoch, performance.now() - startPerf);
}
